export default __webpack_public_path__ + "static/media/Leutrim-Himaj.67670f66.jpg";